import type { FieldValidation } from './fieldValidation';

export const isValidEmail = (value: string) =>
  /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(value);

export const emailValidation: FieldValidation = {
  validateInput: isValidEmail,
  errorMessage: () => 'Please enter a valid email address',
};
